import React, {useEffect, useState} from 'react';
import {
    Box,
    FormControl,
    Grid, Input, InputAdornment,
    ListItem,
    ListItemText,
    Typography
} from "@deere/fuel-react";
import "../assets/Campaigns.scss";
import {NoData} from "../shared/NoData";
import {RatingPgmCritCategoryCard} from "./RatingPgmCritCategoryCard";
import {RatingPgmCriteriaSummaryCard} from "./RatingPgmCriteriaSummaryCard";
import {RatingPgmCriteriaList} from "./RatingPgmCriteriaList";
import {Controller} from "react-hook-form";
import {getCategoryTotal, getCurrentTotal, filterCriteria} from "../shared/utils";
import ReportIcon from "@material-ui/icons/Report";

export const RatingProgramCriteria = ({
                                          control,
                                          currentData,
                                          onSelectStep,
                                          onCriteriaUpdate,
                                          onSubCategoryUpdate,
                                          selectedEditCategoryId,
                                          selectedEditCategoryName
                                      }) => {
    const [categoriesList, setCategoriesList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [categoryId, setCategoryId] = useState(1);
    const [categoryName, setCategoryName] = useState("Quality");
    const [selectedCategoryId, setSelectedCategoryId] = useState(0);
    const [selectedSubCategories, setSelectedSubCategories] = useState([]);

    const noDataMessage = {
        textLine1: "No Criteria available for this SubCategory"
    }

    const handleSelectedCategory = (id, name) => {
        setCategoryId(id);
        setCategoryName(name)
        setSelectedCategoryId(id - 1);
    }

    const handleCriteriaUpdate = (id, requiredFlag, weightValue, selectedFlag) => {
        onCriteriaUpdate(id, requiredFlag, weightValue, selectedFlag)
    }

    const handleSubCategoryUpdate = (id, weightValue) => {
        onSubCategoryUpdate(id, weightValue)
    }

    useEffect(() => {
            onSelectStep(1);
            if (selectedEditCategoryId) {
                setCategoryId(selectedEditCategoryId)
                setCategoryName(selectedEditCategoryName)
                setSelectedCategoryId(selectedEditCategoryId - 1)
            }
            setCategoriesList(currentData.category);
            setIsLoading(false);
        },// eslint-disable-next-line react-hooks/exhaustive-deps
        [currentData]);

    useEffect(() => {
        setSelectedSubCategories(categoriesList.length > 0 && categoriesList.filter(item => item.id === categoryId)[0].subCategories);
    }, [categoryId, categoriesList]);

    return (
        <Grid container>
            <Grid item xs={3}>
                <Box mt={6} mb={2}>
                    <RatingPgmCritCategoryCard
                        loading={isLoading}
                        categoriesList={categoriesList}
                        callbackfn={(item, index) => {
                            const isAnyCriteriaNotValid = currentData.criteria.filter(ele => ele.category.id === item.id).some(ele => ele.isNotValid)
                            return (
                                <ListItem
                                    button
                                    divider={categoriesList.length !== index + 1}
                                    key={index}
                                    selected={index === selectedCategoryId}
                                    className="feedback-List"
                                    onClick={() => handleSelectedCategory(item.id, item.description)}
                                >
                                    <ListItemText
                                        primary={
                                            <React.Fragment>
                                                <Grid container spacing={4}>
                                                    <Grid item xs={9}>
                                                        <Typography size="lg"
                                                                    component="p"
                                                        >
                                                            {item.description}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <Box display="flex"
                                                             justifyContent="flex-end">
                                                            {(item.isNot100Error || item.subCategories.some(ele => ele.isNotTotal) || isAnyCriteriaNotValid) && (
                                                                <ReportIcon fontSize="medium" style={{
                                                                    fill: "#c21020",
                                                                    marginRight: "0.25rem",
                                                                    marginTop: "0.1rem"
                                                                }} display="inline"/>
                                                            )}
                                                            <Typography
                                                                size="lg"
                                                                component="p"
                                                                display="inline"
                                                            >
                                                                {getCategoryTotal(currentData, item.id)}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </React.Fragment>
                                        }
                                    />
                                </ListItem>
                            );
                        }}/>
                </Box>
            </Grid>
            <Grid item xs={9}>
                <Box mt={6} ml={6} mr={6} mb={2}>
                    <RatingPgmCriteriaSummaryCard
                        categoryName={categoryName}
                        categoryId={categoryId}
                        selectedSubCategories={selectedSubCategories}
                        currentData={currentData}/>
                </Box>
                <Box mb={6} ml={6} mr={6} mt={2}>
                    {selectedSubCategories.length > 0 && selectedSubCategories.map((item, index) => {
                        return (
                            <React.Fragment key={index}>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <Box display="flex" flexDirection="column"
                                             alignItems="center">
                                            <Grid container>
                                                <Grid item xs={9}>
                                                    <Box display="inline-flex" justifyContent="flex-start" ml={2} mt={4} mr={4}>
                                                        <Typography variant="h3" component="h3">
                                                            {item.description}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Box display="inline-flex" justifyContent="flex-end" pt={2} mt={4}
                                                          mb={2} ml={4}>
                                                        <Typography variant="h6">
                                                            Current Total: {getCurrentTotal(currentData, item.id)}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={1}>
                                                    <Box display="flex"
                                                         justifyContent="flex-start" mt={4} mb={2}>
                                                        <FormControl>
                                                            <Controller
                                                                control={control}
                                                                defaultValue={item.weight}
                                                                value={item.weight}
                                                                name={`${item.id}-sc-weight`}
                                                                render={({
                                                                             onChange,
                                                                             value
                                                                         }) => (
                                                                    <Input
                                                                        id={`${item.id}-sc-weight`}
                                                                        value={value}
                                                                        sx={{ width: '8ch' }}
                                                                        onChange={(e) => {
                                                                            onChange(e.target.value);
                                                                            handleSubCategoryUpdate(item.id, e.target.value);
                                                                        }}
                                                                        endAdornment={
                                                                            <InputAdornment
                                                                                style={{paddingRight: ".5rem"}}
                                                                                position="end">%</InputAdornment>}
                                                                    />
                                                                )}
                                                            />
                                                        </FormControl>
                                                    </Box>
                                                </Grid>
                                                {item.isNotTotal && (
                                                    <Grid item xs={12}>
                                                        <Box display="flex" justifyContent="flex-end" mb={1}>
                                                            <Typography color="error" size="xs">
                                                                SubCategory total and current total must match
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        {currentData.criteria && currentData.criteria.length > 0 && filterCriteria(currentData, item.id).length > 0 ? filterCriteria(currentData, item.id).map((obj, index) => {
                                            return (
                                                <RatingPgmCriteriaList
                                                    key={index}
                                                    control={control}
                                                    currentCriteria={obj}
                                                    onUpdateCriteria={handleCriteriaUpdate}/>
                                            )
                                        }) : (
                                            <NoData noDataMessage={noDataMessage}/>
                                        )}
                                    </Grid>
                                </Grid>
                            </React.Fragment>
                        )
                    })}
                </Box>
            </Grid>
        </Grid>
    );
};
